import { createContext, useContext, useEffect, useState } from "react";
import api from "../../../api/resources";

export const AlertsContext = createContext(null);

export function AlertsProvider({ children }) {
  const [alerts, setAlerts] = useState(null);
  const [loading, setLoading] = useState(true);

  const init = async () => {
    const initAlerts = async () => {
      const response = await api.getAlerts();
      if (response.ok) {
        const jsonResponse = await response.json();
        setAlerts(jsonResponse);
      }
    };

    setLoading(true);
    await initAlerts();
    setLoading(false);
  };

  useEffect(() => {
    init();
  }, []);

  const value = {
    alerts,
    loading: loading,
  };

  return <AlertsContext value={value}>{children}</AlertsContext>;
}

export function useAlerts() {
  return useContext(AlertsContext);
}
